import { DataList } from "@repo/ui/components/data-list";
import { createFileRoute, Link } from "@tanstack/react-router";
import { REPORT_DEFINITIONS } from "@/features/reports";

export const Route = createFileRoute("/patients/$patientId/_layout/reports/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { patientId } = Route.useParams();

  return (
    <DataList>
      {REPORT_DEFINITIONS.map((definition) => (
        <DataList.NavigatingRow
          key={definition.id}
          renderLink={(props) => (
            <Link
              {...props}
              to="/patients/$patientId/reports/$reportId"
              params={{ patientId, reportId: definition.id }}
            />
          )}
          label={`View ${definition.title}`}
        >
          <DataList.Primary>
            <DataList.Title>{definition.title}</DataList.Title>
            <DataList.Subtitle>{definition.description}</DataList.Subtitle>
          </DataList.Primary>
        </DataList.NavigatingRow>
      ))}
    </DataList>
  );
}
